var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChickenEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.15625C4.30859 0.15625 0.617188 7.53906 0.617188 12.4609C0.617188 16.1523 3.07812 19.8438 8 19.8438C12.9219 19.8438 15.3828 16.1523 15.3828 12.4609C15.3828 7.53906 11.6914 0.15625 8 0.15625Z",
    fill: "#118f84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenEgg);
export default __webpack_public_path__ + "static/media/CHICKEN_EGG.5046fcfd2741975e207f6d60cc1860f7.svg";
export { ForwardRef as ReactComponent };